// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cmKC","content":"styles_content__3oygE"};